import { Spinner } from '@latitude/spinner';
import dynamic from 'next/dynamic';
import Signup from 'components/porto/Signup';
import useIsPortoApp from 'utils/useIsPortoApp';
const ModalWithNoSSR = dynamic(() => import('components/porto/StartModal'), {
  ssr: false,
  loading: () => <Spinner className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
});
export default function Index() {
  const isPorto = useIsPortoApp();
  return isPorto ? <Signup data-sentry-element="Signup" data-sentry-component="Index" data-sentry-source-file="index.tsx" /> : <ModalWithNoSSR description="" notAllowedRoute data-sentry-element="ModalWithNoSSR" data-sentry-component="Index" data-sentry-source-file="index.tsx" />;
}